import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import MultiPoint from "ol/geom/MultiPoint";
import Circle from 'ol/geom/Circle';
import Point from 'ol/geom/Point';
import { GeometryCollection } from 'ol/geom';
import { Circle as CircleStyle, Fill, Stroke, Style, Text } from "ol/style";

import { getLocaleString } from "lib/localization/vendor";
import { getFeatureLabel } from "lib/utilities/feature";

import StyleFeature from "styles/script/stylefeature";
import RasterFeatureStyle from "styles/script/styleraster";
import StyleAnnotationFeatureStreetView from 'styles/script/styleannotationfeaturestreetview';
import StyleAnnotationArrowFeature from 'styles/script/styleannotationarrowfeature';

export default function StyleSelector(feature:Feature<Geometry>) {
	const overrides:Style[] = getOverrides(feature);
	const styles:Style[] = StyleFeature(feature);
	
	styles.shift();
	styles.unshift(...overrides);
	
	return styles;
}

function getOverrides(feature:Feature<Geometry>) {
	const styles:any[] = [];
	
	if(feature.get("rasterimg"))
		return RasterFeatureStyle(feature);
	
	if(feature.get('annotation') === 'streetview')
		styles.unshift(...StyleAnnotationFeatureStreetView(feature));
	
	if(feature.get('annotation') === 'arrow')
		styles.unshift(...StyleAnnotationArrowFeature(feature, true));
	
	const isMeasurement: boolean = feature.get("origin") == 'measurement';
	
	styles.push(
		new Style({
			stroke: new Stroke({
				color: !isMeasurement ? "blue" : "red",
				width: 3,
				lineDash: [5, 5],
			}),
			fill: new Fill({
				color: !isMeasurement
					? "rgba(255, 255, 255, 0.5)"
					: "rgba(255, 165, 0, 0.5)",
			})
		}),
		new Style({
			image: new CircleStyle({
				radius: 7,
				fill: new Fill({
					color: !isMeasurement ? "blue" : "red",
				}),
			}),
			geometry: (feature:any) => {
				let coordinates;
				switch (feature.getGeometry().getType()) {
					case "Polygon":
						coordinates = feature.getGeometry().getCoordinates()[0];
						break;
					case "Point":
						coordinates = [feature.getGeometry().getCoordinates()];
						break;
					case "LineString":
						coordinates = feature.getGeometry().getCoordinates();
						break;
					case "Circle": {
						const circle:Circle = feature.getGeometry() as Circle;
						const point:Point = new Point(circle.getCenter());
						
						return new GeometryCollection([circle, point]);
					}
					case "MultiPolygon":
						const coords: any[] = [];
	
						feature
							.getGeometry()
							.getCoordinates()
							.forEach((coordset: any) => {
								coordset.forEach((c: any) => coords.push(...c));
							});
						
						coordinates = coords;
						break;
				}
				return new MultiPoint(coordinates);
			},
		})
	);
	
	return styles;
}